import { render, staticRenderFns } from "./InsureInfoDetailCustom.vue?vue&type=template&id=127997d3&scoped=true&"
import script from "./InsureInfoDetailCustom.vue?vue&type=script&lang=js&"
export * from "./InsureInfoDetailCustom.vue?vue&type=script&lang=js&"
import style0 from "./InsureInfoDetailCustom.vue?vue&type=style&index=0&id=127997d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127997d3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('127997d3')) {
      api.createRecord('127997d3', component.options)
    } else {
      api.reload('127997d3', component.options)
    }
    module.hot.accept("./InsureInfoDetailCustom.vue?vue&type=template&id=127997d3&scoped=true&", function () {
      api.rerender('127997d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "meibao-insure/src/components/InsureInfoDetailCustom.vue"
export default component.exports